import * as Bixby from '../core';

export abstract class CovenantReviewService {
  private static baseUrl = Bixby.Constants.API_COVENANTREVIEWCONTROLLER;

  public static async getCovenantReviewGlobalFeedAsync(
    request: Bixby.Models.CovenantReviewGlobalFeedRequest
  ): Promise<Bixby.Models.PagedResult<Bixby.Models.CovenantReviewArticle>> {
    const url = `${CovenantReviewService.baseUrl}/${Bixby.Constants.API_ACTION_COVENANT_REVIEW_GLOBAL_FEED}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.post(route, {
      skip: request.skip,
      take: request.take,
      covenantReviewQuickFilterTypeId: request.covenantReviewQuickFilterTypeId
    });
  }

  public static async getCovenantReviewGlobalFeedForCompanyAsync(
    request: Bixby.Models.CovenantReviewGlobalFeedCompanyRequest
  ): Promise<Bixby.Models.PagedResult<Bixby.Models.CovenantReviewArticle>> {
    const url = `${CovenantReviewService.baseUrl}/${Bixby.Constants.API_ACTION_COVENANT_REVIEW_GLOBAL_FEED_COMPANY}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.post(route, {
      skip: request.skip,
      take: request.take,
      covenantReviewQuickFilterTypeId: request.covenantReviewQuickFilterTypeId,
      bixbyCompanyId: request.bixbyCompanyId,
      creditSightsCompanyId: request.creditSightsCompanyId
    });
  }
}
